var map = {
	"./Map/resources/components/canvas/blocks/modules/map/admin/BlockPanel.vue": 6112,
	"./Map/resources/components/canvas/blocks/modules/map/block.js": 1561,
	"./Shop/resources/components/canvas/blocks/modules/shop/admin/BlockPanel.vue": 7248,
	"./VlinderTuin/resources/components/canvas/blocks/modules/VlinderTuin/admin/BlockPanel.vue": 3828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1335;